export const fonts = {
	H1: `calc(38px + (46 - 38) * ((100vw - 375px) / (1762 - 375)))`,
	H2: `calc(32px + (38 - 32) * ((100vw - 375px) / (1762 - 375)))`,
	H3: `calc(30px + (36 - 30) * ((100vw - 375px) / (1762 - 375)))`,
	H4: `calc(26px + (32 - 26) * ((100vw - 375px) / (1762 - 375)))`,
	H5: `calc(24px + (30 - 24) * ((100vw - 375px) / (1762 - 375)))`,
	H6: `calc(18px + (20 - 18) * ((100vw - 375px) / (1762 - 375)))`,
	P: `calc(16px + (18 - 16) * ((100vw - 375px) / (1762 - 375)))`,
	SPAN: `calc(14px + (18 - 14) * ((100vw - 375px) / (1762 - 375)))`,
	A: `calc(16px + (18 - 16) * ((100vw - 375px) / (1762 - 375)))`,
	BUTTON: `18px`,
	CAPTION: `calc(14px + (14 - 14) * ((100vw - 375px) / (1762 - 375)))`,
};

export const fontsLineHeight = {
	H1: `calc(44px + (50 - 44) * ((100vw - 375px) / (1762 - 375)))`,
	H2: `calc(38px + (44 - 38) * ((100vw - 375px) / (1762 - 375)))`,
	H3: `calc(36px + (42 - 36) * ((100vw - 375px) / (1762 - 375)))`,
	H4: `calc(32px + (38 - 32) * ((100vw - 375px) / (1762 - 375)))`,
	H5: `calc(30px + (38 - 30) * ((100vw - 375px) / (1762 - 375)))`,
	H6: `calc(22px + (24 - 22) * ((100vw - 375px) / (1762 - 375)))`,
	P: `calc(22px + (24 - 22) * ((100vw - 375px) / (1762 - 375)))`,
	SPAN: `1.6rem`,
	A: `calc(22px + (24 - 22) * ((100vw - 375px) / (1762 - 375)))`,
	BUTTON: `22px`,
	CAPTION: `19px`,
};
